<template>
	<div class="delete-event-winner">
		<EventWinnerMappedPdtTable
			v-model="checkedProduct"
			:productList="productList"
		/>
		<div class="btn-wrap-main">
			<button
				type="button"
				class="btn-main red"
				v-text="'삭제'"
				@click="deleting"
			/>
		</div>
		<button
			type="button"
			class="delete-event-winner__close-btn"
			@click="closing"
		>
			<i class="fas fa fa-times delete-event-winner__close-btn-icon" />
		</button>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import EventWinnerMappedPdtTable from '../EventWinnerMappedPdtTable.vue';

	export default {
		name: 'SelectProductForEventWinnerRemove',
		components: {
			EventWinnerMappedPdtTable,
		},
		data() {
			return {
				checkedProduct: [],
			};
		},
		computed: {
			...mapState({
				params: state => state.modal.params,
			}),
			removeIdList() {
				return this.params.removeIdList;
			},
			productList() {
				return this.params.winnerMappedPdtList
					.filter(pdt =>
						pdt.candidates.some(winner =>
							this.removeIdList.some(
								removeId => removeId === winner.idRegister
							)
						)
					)
					.map(({ idProduct, productName }) => ({
						idProduct,
						productName,
					}));
			},
		},
		methods: {
			closing() {
				this.$emit('close');
			},
			deleting() {
				if (this.checkedProduct.length < 1) {
					alert('제품을 선택해주세요.');
					return;
				}
				this.params.removeWinner({
					pdtIdList: this.checkedProduct,
					removeIdList: this.removeIdList,
				});
				this.closing();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.delete-event-winner {
		&__close-btn {
			position: absolute;
			right: 35px;
			top: 30px;
			padding: 5px;

			&-icon {
				font-size: 30px;
			}
		}
	}
</style>
